type UserWithRole = {
  roleId?: number | string | null;
} | null | undefined;

export const USER_ROLES = {
  SUPERADMIN: 100,
  ADMIN: 200,
  CUSTOMERSERVICE: 300,
  TRANSPORTATION:1000,
  OPERATIONADMIN: 400,
  BOARDINGOFFICER: 500,
  WAREHOUSE: 600,
  DRIVER: 700,
  HR: 800,
  ACCOUNTS: 900,
  PAYABLE: 1100,
  RECEIVABLE: 1200,
  MAINTENANCE: 1300,
} as const;

export const hasRole = (user: UserWithRole, requiredRoles: number[]): boolean => {
  return true; // Bypassed to allow all roles to access all pages
};

export const isSuperAdmin = (user: UserWithRole): boolean => {
  const roleId = typeof user?.roleId === 'string' ? Number(user.roleId) : user?.roleId;
  return roleId === USER_ROLES.SUPERADMIN;
};

export const isAdmin = (user: UserWithRole): boolean => {
  const roleId = typeof user?.roleId === 'string' ? Number(user.roleId) : user?.roleId;
  return roleId === USER_ROLES.ADMIN || roleId === USER_ROLES.SUPERADMIN;
};
